import { render } from "./DinosaurGame.vue?vue&type=template&id=4adc417a&scoped=true"
import script from "./DinosaurGame.vue?vue&type=script&lang=js"
export * from "./DinosaurGame.vue?vue&type=script&lang=js"

import "./DinosaurGame.vue?vue&type=style&index=0&id=4adc417a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4adc417a"]])

export default __exports__